import { Globe, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import type { Contact } from '@/types'

interface EmpresaContactEditFormProps {
  isNew: boolean
  contactEditData: Partial<Contact>
  setContactEditData: (data: Partial<Contact>) => void
  saving: boolean
  syncing: boolean
  editingContactId: string
  onCancel: () => void
  onSave: () => void
  onSyncAvatar: (contatoId: string) => void
}

export function EmpresaContactEditForm({
  isNew,
  contactEditData,
  setContactEditData,
  saving,
  syncing,
  editingContactId,
  onCancel,
  onSave,
  onSyncAvatar,
}: EmpresaContactEditFormProps) {
  return (
    <div className='glass-card p-6 space-y-4 border border-[var(--glass-border)] rounded-xl'>
      <h4 className='text-sm font-semibold text-[var(--font-color-body)] uppercase tracking-wider border-b border-[var(--glass-border)] pb-2'>
        {isNew ? 'Adicionar Novo Contato' : 'Editar Contato'}
      </h4>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
        <div className='flex flex-col gap-1.5'>
          <label className='text-[var(--font-color-label)] uppercase tracking-wider font-medium text-[11px]'>Nome</label>
          <Input
            value={contactEditData.nome || ''}
            onChange={(e) => setContactEditData({ ...contactEditData, nome: e.target.value })}
            placeholder='Nome completo'
            className='text-sm w-full'
          />
        </div>
        <div className='flex flex-col gap-1.5'>
          <label className='text-[var(--font-color-label)] uppercase tracking-wider font-medium text-[11px]'>Cargo</label>
          <Input
            value={contactEditData.cargo || ''}
            onChange={(e) => setContactEditData({ ...contactEditData, cargo: e.target.value })}
            placeholder='Ex: Diretor de TI'
            className='text-sm w-full'
          />
        </div>
        <div className='flex flex-col gap-1.5'>
          <label className='text-[var(--font-color-label)] uppercase tracking-wider font-medium text-[11px]'>Email</label>
          <Input
            type='email'
            value={contactEditData.email || ''}
            onChange={(e) => setContactEditData({ ...contactEditData, email: e.target.value })}
            placeholder='email@exemplo.com'
            className='text-sm w-full'
          />
        </div>
        <div className='flex flex-col gap-1.5'>
          <label className='text-[var(--font-color-label)] uppercase tracking-wider font-medium text-[11px]'>Telefone</label>
          <Input
            value={contactEditData.telefone || ''}
            onChange={(e) => setContactEditData({ ...contactEditData, telefone: e.target.value })}
            placeholder='(00) 00000-0000'
            className='text-sm w-full'
          />
        </div>
        <div className='flex flex-col gap-1.5 md:col-span-2'>
          <label className='text-[var(--font-color-label)] uppercase tracking-wider font-medium text-[11px]'>LinkedIn URL</label>
          <div className='flex gap-2'>
            <Input
              value={contactEditData.linkedin || ''}
              onChange={(e) => setContactEditData({ ...contactEditData, linkedin: e.target.value })}
              placeholder='https://linkedin.com/in/...'
              className='text-sm flex-1'
            />
            {!isNew && (
              <Button
                type='button'
                variant='secondary'
                size='sm'
                onClick={() => onSyncAvatar(editingContactId)}
                icon={syncing ? <Loader2 size={14} className='animate-spin' /> : <Globe size={14} />}
                title='Sincronizar Foto via Gravatar'
              />
            )}
          </div>
        </div>
        <div className='flex items-center gap-3 mt-2 md:col-span-2'>
          <label className='relative inline-flex items-center cursor-pointer select-none'>
            <input
              type='checkbox'
              className='sr-only peer'
              checked={!!contactEditData.decisor}
              onChange={(e) => setContactEditData({ ...contactEditData, decisor: e.target.checked })}
            />
            <div className='w-9 h-5 bg-white/[0.04] border border-white/[0.06] rounded-full peer peer-checked:after:translate-x-full after:content-[""] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[var(--brand-primary)]' />
            <span className='ml-3 text-xs font-bold text-[var(--font-color-body)]'>É Decisor?</span>
          </label>
        </div>
      </div>

      <div className='flex items-center justify-end gap-2 border-t border-[var(--glass-border)] pt-4'>
        <Button variant='ghost' size='sm' onClick={onCancel}>Cancelar</Button>
        <Button variant='primary' size='sm' onClick={onSave} disabled={saving}>
          {saving ? 'Salvando...' : 'Salvar Contato'}
        </Button>
      </div>
    </div>
  )
}
